import * as React from "react";
import PropTypes from "prop-types";
import GBStdTable from "../../../Library/Tables/GBStdTable";

class SCTargetTable extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        catInfo: PropTypes.object,
        mstIDsObj: PropTypes.object,
        value: PropTypes.arrayOf(PropTypes.array),
        onChange: PropTypes.func,
    };

    static defaultProps = {
        catInfo: null,
        mstIDsObj: PropTypes.object,
        value: [
            ["", "Month"],
            ["Value", 1],
        ],
        onChange: () => console.log("onChange"),
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        try {
            let MAX_VALUE = 999999999;
            let styles = {
                innerPage: {
                    margin: 20,
                },
            };

            let values = JSON.parse(JSON.stringify(this.props.value));

            return (
                <div style={styles.innerPage}>
                    <h5>Target</h5>

                    <GBStdTable
                        id="TargetsTable"
                        minHeight={75}
                        maxHeight={75}
                        packTable={{
                            GBFixedRows: 1,
                            GBFixedCols: 1,
                            GBRowCount: 1,
                            GBColCount: 2, //13
                            GBColWidths: [300, 100],
                            MinAllowedVal: [
                                [0, 0],
                                [0, 0],
                            ],
                            MaxAllowedVal: [
                                [0, 0],
                                [0, MAX_VALUE],
                            ],
                            tableData: {
                                value: values,
                            },
                            AllowBlanks: true, // mark
                        }}
                        onSheetCellsChanged={this.props.onChange}
                    />
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"GBStartScreenFormDiv"}
                    key={"GBStartScreenFormDiv"}
                >
                    <h3 key={"GBStartScreenFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCTargetTable;
